<div class="overlay">
  <div class="view {{view}}">
    <app-icon (click)="closed()" class="icon__def icon__close" width="12" height="12" file="common" icon="close-mobile-modal"></app-icon>

    <div class="close-mobile-new" *ngIf="deviceService.isMobile()" (click)="closed()">
      <app-icon class="icon__def" file="common" icon="close-mobile-modal"></app-icon>
    </div>

    <div class="header">
      <app-icon class="header__logo" width="60" height="60" file="common" icon="logo"></app-icon>
    </div>

    <!-- Sign in -->
    <div *ngIf="view === 'signin' || view === 'social'" class="body">
      <h2>{{ 'auth.signin.action1' | customLocale }}</h2>
      <view-auth-signin class="body__item" (on_action)="on_form_submit($event)"></view-auth-signin>
    </div>

    <!-- Sign up -->
    <div *ngIf="view === 'signup'" class="body">
      <h2>{{ 'auth.signup.action1' | customLocale }}</h2>
      <view-auth-signup class="body__item" (on_action)="on_form_submit($event)"></view-auth-signup>
    </div>

    <!-- Password reset -->
    <div *ngIf="view === 'restore'" class="body">
      <h2>{{ 'auth.restore.password-recovery' | customLocale }}</h2>
      <view-auth-restore class="body__item" (on_action)="on_form_submit($event)"></view-auth-restore>
    </div>
  </div>
</div>
